import {createTheme } from '@mui/material/styles';

//Primary website color
export const primaryColor = "#5f09c2"


export const theme = createTheme({
  
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#f7f9fc', // Light background similar to the input
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
        columnHeaders: {
          color: 'black', // Header text color
          fontWeight: 600,
          fontSize: '14px',
          borderRadius: '8px 8px 0 0', // Rounded top corners
        },
        cell: {
          backgroundColor: '#fff', // Cell background color
          padding: '12px', // Similar padding as input field
          borderRadius: '8px', // Rounded corners for cells
          transition: 'all 0.3s ease',
          '&:hover': {
            borderColor: primaryColor, // Hover effect
          },
        },
        row: {
          '&:nth-of-type(even)': {
            backgroundColor: '#f7f9fc', // Alternating row colors
          },
        },
        toolbar: {
          backgroundColor: primaryColor, // Toolbar background color
          color: 'white', // Toolbar text color
          borderRadius: '8px 8px 0 0',
        },
      },
    },
    uiButton: {
      styleOverrides: {
        root: {
          backgroundColor: primaryColor, // Button background color
          color: 'white', // Button text color
          borderRadius: '8px', // Rounded corners for buttons
          padding: '8px 16px', // Padding for buttons
          fontWeight: 600,
          fontSize: '14px',
          '&:hover': {
            backgroundColor: '#4b059a', // Darker shade for hover effect
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          },
          '&:disabled': {
            backgroundColor: '#d1c8e5', // Disabled button background color
            color: '#a3a3a3', // Disabled text color
          },
        },
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      root: {
        backgroundColor: '#f7f9fc', // Light background
        borderRadius: '8px', // Rounded corners
        padding: '14px', // Padding similar to input fields
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Box shadow for a soft effect
        '&:hover': {
          borderColor: primaryColor, // Hover effect
        },
        '&:focus': {
          borderColor: primaryColor, // Focus border color
          outline: 'none', // Remove outline on focus
          boxShadow: '0 0 6px rgba(0, 123, 255, 0.5)', // Focus box shadow
        },
        '&[disabled]': {
          backgroundColor: '#e9ecef', // Disabled background color
          color: '#6c757d', // Disabled text color
          cursor: 'not-allowed', // Disabled cursor
        },
      },
    },
  },
  typography: {
    h1: {
      fontSize: '36px', // Custom font size for h1
      fontWeight: 700,
    },
    h2: {
      fontSize: '30px', // Custom font size for h2
      fontWeight: 600,
    },
    h3: {
      fontSize: '24px', // Custom font size for h3
      fontWeight: 500,
    },
    h4: {
      fontSize: '20px', // Custom font size for h4
      fontWeight: 400,
    },
    h5: {
      fontSize: '18px', // Custom font size for h5
      fontWeight: 400,
    },
    h6: {
      fontSize: '16px', // Custom font size for h6
      fontWeight: 400,
    },
    p: {
      fontSize: '16px', // Custom font size for paragraphs
      lineHeight: '1.5', // Line height for better readability
    },
    body1: {
      fontSize: '16px', // Body text size
      fontWeight: 400,
    },
    body2: {
      fontSize: '14px', // Smaller body text size
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: '16px', // Subtitle text size
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: '14px', // Smaller subtitle text size
      fontWeight: 500,
    },
    caption: {
      fontSize: '12px', // Small text size for captions
      fontWeight: 300,
    },
  },
});
